// extracted by mini-css-extract-plugin
export var alignCenter = "_7f-d";
export var bannerShown = "_7f-6";
export var buttonContent = "_7f-0";
export var cardList = "_7f-1";
export var centerContent = "_7f-2";
export var chevron = "_7f-3";
export var closePanelButton = "_7f-k";
export var conversationContextContainer = "_7f-l";
export var conversationDetailContainer = "_7f-4";
export var detailWrapper = "_7f-7";
export var dropdownButton = "_7f-e";
export var dropdownTitle = "_7f-9";
export var fullHeight = "_7f-5";
export var hidden = "_7f-a";
export var icon = "_7f-b";
export var mergeSuggestionWrapper = "_7f-m";
export var panel = "_7f-i";
export var portalButtonsWrapper = "_7f-c";
export var right = "_7f-j";
export var tableSummaryContainer = "_7f-8";
export var tableSummaryHeader = "_7f-g";
export var threeDotsButton = "_7f-f";
export var wide = "_7f-h";